module.exports = __webpack_public_path__ + "img/16.8f6864fc.png";